module.exports = __webpack_public_path__ + "static/Olive_Slime-7a901a0f3db62e76cdcf6d18359c2fd3.jpg";